import { config } from 'api';
import { UNKNOWN_ERROR } from 'utils/errors';
import { getHolidays } from './orSettings';

const CANCEL_ORDER_URL = `${config.apiBasePath}/slotsub/orders`;

export const OR_TOGGLE_CANCEL_ORDER_MODAL = 'OR_TOGGLE_CANCEL_ORDER_MODAL';
export const OR_REQUEST_ORDER_CANCEL = 'OR_REQUEST_ORDER_CANCEL';
export const OR_ORDER_CANCEL_SUCCESS = 'OR_ORDER_CANCEL_SUCCESS';
export const OR_ORDER_CANCEL_ERROR = 'OR_ORDER_CANCEL_ERROR';

export function toggleCancelOrderModal(orderNumber) {
  return {
    type: OR_TOGGLE_CANCEL_ORDER_MODAL,
    orderNumber,
  };
}

export function requestOrderCancel() {
  return {
    type: OR_REQUEST_ORDER_CANCEL,
  };
}

export function orderCancelSuccess(orderNumber) {
  return {
    type: OR_ORDER_CANCEL_SUCCESS,
    orderNumber,
  };
}

export function orderCancelError({ error }) {
  return {
    type: OR_ORDER_CANCEL_ERROR,
    error,
  };
}

export function cancelOrder(orderNumber) {
  return (dispatch, getState, { network }) => {
    dispatch(requestOrderCancel());
    return network.del(`${CANCEL_ORDER_URL}/${orderNumber}`)
      .then(() => {
        dispatch(orderCancelSuccess(orderNumber));
        dispatch(getHolidays());
      })
      .catch(err => {
        dispatch(orderCancelError(err.data || UNKNOWN_ERROR));
      });
  };
}
